import { render, staticRenderFns } from "./VstRegChannel.vue?vue&type=template&id=9d8d19d0&"
import script from "./VstRegChannel.vue?vue&type=script&lang=js&"
export * from "./VstRegChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports